module.exports = __webpack_public_path__ + "static/media/img_4.e8f7906d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/gallery/img_4.jpg
// module id = 544
// module chunks = 0